// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private activeTheme = new BehaviorSubject('blankThemeProps');

    constructor() { }

    public getActiveTheme() {
        return this.activeTheme.asObservable();
    }

    public setActiveTheme(name) {
        this.activeTheme.next(name);
    }
}
